import * as React from 'react';

import _t from 'i18n!nls/account-settings';

import 'css!./__styles__/FormError';

function getMessages(): { [key: string]: string } {
  return {
    password: _t('Please confirm your password'),
    code: _t('Your two-factor code did not match. Please try again.'),
  };
}

type Props = {
  fields: string[];
};

export default class FormError extends React.Component<Props> {
  render() {
    const messages = getMessages();
    return (
      <span>
        {this.props.fields.map((field) => {
          const message = messages[field];
          if (!message) {
            return null;
          }

          return (
            <span role="alert" className="rc-TwoFactorFormError">
              {message}
            </span>
          );
        })}
      </span>
    );
  }
}
